import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const TOMOS = [{
  emoji: '📘',
  title: 'TOMO 1 — Hackeá tu Realidad',
  tagline: 'Las 100 frases que reescriben tu diálogo interno.',
  desc: 'Acá empieza todo: 100 frases de amor propio ordenadas en las 10 áreas donde más te castigás. No son frases para colgar en la heladera; están hechas para que, leyéndolas 5 minutos por día, se vuelvan tu nueva voz interna: la que te impulsa en vez de frenarte.',
  bullets: ['100 afirmaciones originales en 10 áreas de tu vida.', 'El método de los 5 minutos para que actúen todos los días.', 'Un ejercicio "Aplicalo" al final de cada bloque.']
}, {
  emoji: '📗',
  title: 'TOMO 2 — El Protocolo de 21 Días',
  tagline: 'Convertí las frases en tu nueva forma de pensar.',
  desc: 'Leer las frases está bueno, pero el cambio real llega cuando se vuelven hábito. Este es tu plan día por día durante 21 días, en 3 etapas: tomás conciencia de cómo te hablás, instalás los pensamientos nuevos y empezás a decidir desde tu nueva versión.',
  bullets: ['Un ejercicio guiado por día, durante 21 días.', '3 fases: Conciencia → Reprogramación → Nueva Identidad.', 'Trackers para medir tu avance y no abandonar.']
}, {
  emoji: '📕',
  title: 'TOMO 3 — Anti-Autosabotaje',
  tagline: 'Desarmá las creencias que te frenan sin que lo notes.',
  desc: '¿Por qué arrancás con todo y a la semana lo dejás? Por creencias escondidas que te boicotean sin que lo notes. Este tomo te ayuda a detectar tus 7 patrones de autosabotaje y te da un ejercicio para desarmar cada uno. Es el que hace que el cambio se sostenga en el tiempo.',
  bullets: ['Test para descubrir tus 7 patrones de autosabotaje.', 'Un ejercicio concreto para desarmar cada uno.', 'Herramientas para frenar el sabotaje en el momento.']
}];
export function WhatYouGet() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 max-w-3xl mx-auto pt-[40px] pb-[40px]" data-id="element-235">
      <h2 className="font-serif text-3xl md:text-4xl text-brown font-bold text-center mb-12" data-id="element-236">
        Qué recibís, en detalle
      </h2>

      <div className="space-y-4 mb-12" data-id="element-237">
        {TOMOS.map((tomo, i) => <div key={i} className="bg-white rounded-2xl border border-gold/20 overflow-hidden shadow-sm" data-id="element-238">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-cream/50 transition-colors" aria-expanded={openIndex === i} data-id="element-239">
              <div className="flex items-center gap-4 pr-4" data-id="element-240">
                <span className="text-2xl" data-id="element-241">{tomo.emoji}</span>
                <div data-id="element-242">
                  <h3 className="font-sans font-bold text-brown text-lg" data-id="element-243">
                    {tomo.title}
                  </h3>
                  <p className="font-sans text-sm text-brown/60 mt-1" data-id="element-244">
                    {tomo.tagline}
                  </p>
                </div>
              </div>
              <ChevronDown className={`w-5 h-5 text-gold shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-245" />
            </button>

            <AnimatePresence initial={false} data-id="element-246">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-247">
                  <div className="px-6 pb-6 pt-2 border-t border-cream" data-id="element-248">
                    <p className="font-sans text-brown/80 leading-relaxed mb-6" data-id="element-249">
                      {tomo.desc}
                    </p>
                    <ul className="space-y-3" data-id="element-250">
                      {tomo.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-3 font-sans text-sm text-brown/90" data-id="element-251">
                          <div className="w-1.5 h-1.5 rounded-full bg-gold mt-2 shrink-0" data-id="element-252" />
                          <span data-id="element-253">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>

      <div className="bg-gold/10 p-6 rounded-xl text-center border border-gold/20" data-id="element-254">
        <p className="font-sans font-medium text-brown" data-id="element-255">
          El camino:{' '}
          <span className="font-bold text-gold" data-id="element-256">instalás las frases</span> →{' '}
          <span className="font-bold text-gold" data-id="element-257">las convertís en hábito</span> →{' '}
          <span className="font-bold text-gold" data-id="element-258">
            eliminás lo que te boicotea
          </span>
          .
        </p>
      </div>
    </section>;
}